var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReenviarAcuses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reenviar-acuses",
    transform: "translate(11857.383 16218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24805",
    "data-name": "Trazado 24805",
    d: "M12.5,25A12.5,12.5,0,1,1,25,12.5,12.514,12.514,0,0,1,12.5,25m0-23.809A11.309,11.309,0,1,0,23.808,12.5,11.321,11.321,0,0,0,12.5,1.191",
    transform: "translate(-11857.383 -16218)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-share",
    "data-name": "Icon awesome-share",
    d: "M14.342,6.744,9.33,2.417a.684.684,0,0,0-1.13.517V5.213c-4.574.052-8.2.969-8.2,5.3a5.821,5.821,0,0,0,2.373,4.389.507.507,0,0,0,.8-.53C1.881,10.246,3.785,9.149,8.2,9.086v2.5a.684.684,0,0,0,1.13.517l5.011-4.328A.684.684,0,0,0,14.342,6.744Z",
    transform: "translate(-11852.289 -16213.628)",
    fill: "none",
    stroke: "#d5007f",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReenviarAcuses);
export default __webpack_public_path__ + "static/media/Reenviar-acuses.4bcda994e764003ff5cb9eef8d2c6a1d.svg";
export { ForwardRef as ReactComponent };